import { Label3D } from "../../../../gui/Label3D";
import { HUD_LAYER, HudLayer } from "../HudLayer";
import { DT_TRACE_DRAG_BEGIN, DT_TRACE_DRAG_HOVER, DT_TRACE_DRAG_STOP } from "../../../DtEventTypes";

const avp = Autodesk.Viewing.Private;

const COLLAPSIBLE_LABELS_LIMIT = 6;

export class TraceLayer_DEPRECATED extends HudLayer {
  #dragTarget = null;

  constructor(facility, hud, viewer) {
    super(HUD_LAYER.TRACE.id, facility, hud, viewer);
    this.labels = [];

    this.boundOnTraceDragStart = this.onTraceDragStart.bind(this);
    this.boundOnTraceDragEnd = this.onTraceDragEnd.bind(this);
  }

  isDragging() {
    return !!this.#dragTarget;
  }

  addTraceLabel(element, color, iconPath, draggable) {
    if (this.isDragging()) return;

    let label = this.hud.getElementLabel(element);
    if (label) {




      // Should we replace existing label in some cases? (e.g. not a pin or color/iconPath changes)
      //
      // For now, elements that can be traced cannot have labels in other layers (label/space/asset)
      // we're going to have problems if we have multiple labels for the same element in different layers
    } else {label = this.hud.addLabel(element.model, element.dbId, true, { clickSelects: true, bgColor: color, iconPath, appendTo: this.dom });label.setElement(element); // Update HudPinLabel attributes
      label.setCollapsible(this.labels.length >= COLLAPSIBLE_LABELS_LIMIT);
      label.inFocus = false;

      this.labels.push(label);
      if (this.labels.length === COLLAPSIBLE_LABELS_LIMIT) {
        for (const label of this.labels) {
          label.isRepellable = false;
          label.setCollapsible(true);
        }
      }

      label.container.setAttribute('data-test-id', `name:${label.textDiv.textContent}`);
    }

    // Update general (Label3D) attributes
    label.setVisible(true);
    label.offsetAnimControl?.skip();
    label.isRepellable = this.labels.length < COLLAPSIBLE_LABELS_LIMIT;
    label.setOffset({ x: 0, y: 0 }); // will interact with repelling simulation.

    if (draggable && !label.isDraggable) {
      label.setDraggable(true);
      label.addEventListener(Label3D.Events.DRAG_START, this.boundOnTraceDragStart, { once: true });
    }

    return label;
  }

  handleMouseMove(event) {
    if (this.#dragTarget) {
      // Check if the left mouse button is still pressed and stop dragging if it's not
      if (event.buttons !== 1) {
        this.onTraceDragEnd();
        return;
      }

      if (event.canvasX === undefined || event.canvasY === undefined) {
        // Add canvas coords to event
        this.viewer.toolController.__clientToCanvasCoords(event);
      }

      this.#dragTarget.dragMove(event.canvasX, event.canvasY);

      const vImpl = this.viewer.impl;
      const idRes = [];
      const vpVec = vImpl.clientToViewport(event.canvasX, event.canvasY);
      const dbId = vImpl.renderer().idAtPixel(vpVec.x, vpVec.y, idRes);
      const model = vImpl.modelQueue().findModel(idRes[1]);

      if (dbId && model) {
        this.viewer.dispatchEvent({ type: DT_TRACE_DRAG_HOVER, dbId, model });
      }

      return true; // stop propagation
    }
  }

  onTraceDragStart(event) {
    if (!this.#dragTarget) {
      this.#dragTarget = event.target.clone();
      this.#dragTarget.dragStart();

      // Since the initial mousedown event didn't happen on the cloned label,
      // we need to add a mouseup event listener to know when dragging stops
      this.#dragTarget.addDocumentEventListener("mouseup", this.boundOnTraceDragEnd, { once: true });

      // Immediately move the cloned label to the mouse position
      this.#dragTarget.dragMove(event.canvasX, event.canvasY);

      this.clear();

      const { model, dbId } = this.#dragTarget.getElement();

      this.viewer.dispatchEvent({ type: DT_TRACE_DRAG_BEGIN, dbId, model });
    }
  }

  onTraceDragEnd() {
    if (this.#dragTarget) {
      this.#dragTarget.dragStop();
      this.#dragTarget.dtor();
      this.#dragTarget = null;

      this.viewer.dispatchEvent({ type: DT_TRACE_DRAG_STOP });
    }
  }

  clear() {
    const hud = this.hud;

    for (const label of this.labels) {
      label.offsetAnimControl?.skip();
      label.isRepellable = false;
      hud.deleteLabel(label.labelId);
    }

    hud.update();

    this.labels.length = 0;
  }
}